document.addEventListener("turbo:load", function() {
  $('.js-close-flash-message').fadeOut(5000)
})
